






















































































import { Component, Vue, Emit } from 'vue-property-decorator'
import { Services } from '@finx/web-repository'
import draggable from 'vuedraggable'
import ProvisaoStore from '@/store/Provisao'
import DOM from '@/factories/DOM'

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({
  components: {
    draggable,
  },
})

export default class ViewProvisao extends Vue {
  user: any = {}

  get isAdicionar(): Boolean {
    const isAdicionar = this.$route.params.action !== 'editar'
    return isAdicionar
  }

  get getIsEditProvisao() {
    return ProvisaoStore.getters.IS_EDIT_PROVISAO
  }

  get provisao() {
    return ProvisaoStore.getters.PROVISAO
  }

  get showProvisaoDadosIniciais(): Boolean {
    return ProvisaoStore.getters.DIALOG_DADOS_INICIAIS
  }

  set showProvisaoDadosIniciais(newValue) {
    ProvisaoStore.commit('SET_DIALOG_DADOS_INICIAIS', newValue)
  }

  get showProvisaoFuncao(): Boolean {
    return ProvisaoStore.getters.DIALOG_FUNCAO
  }

  set showProvisaoFuncao(newValue) {
    ProvisaoStore.commit('DIALOG_FUNCAO', newValue)
  }

  get showProvisaoInformacoesAdicionais(): Boolean {
    return ProvisaoStore.getters.DIALOG_INFORMACOES_ADICIONAIS
  }

  set showProvisaoInformacoesAdicionais(newValue) {
    ProvisaoStore.commit('DIALOG_INFORMACOES_ADICIONAIS', newValue)
  }

  get showProvisaoResumo(): Boolean {
    return ProvisaoStore.getters.DIALOG_RESUMO
  }

  set showProvisaoResumo(newValue) {
    ProvisaoStore.commit('DIALOG_RESUMO', newValue)
  }

  get getProcedimentos() {
    return ProvisaoStore.getters.PROCEDIMENTOS
  }

  set getProcedimentos(newValue) {
    ProvisaoStore.dispatch('SET_PROCEDIMENTOS', newValue)
  }

  onListProcedimentosMove(item) {
    if (item.newIndex === 0) {
      this.getProcedimentos[item.newIndex].quantidade = 1
      this.getProcedimentos[item.newIndex].viaAcesso = 1
    }

    ProvisaoStore.dispatch('SET_PROCEDIMENTOS', this.getProcedimentos)
    ProvisaoStore.dispatch('CALCULADORA_PROVISAO')
  }

  async mounted() {
    DOM.toggleBodyOverflow()

    if (this.isAdicionar) {
      ProvisaoStore.dispatch('RESET_PROVISAO')
    }

    await this.getUser()
  }

  beforeRouteLeave(to, from, next) {
    this.showProvisaoDadosIniciais = false
    DOM.toggleBodyOverflow()
    next()
  }

  async getUser() {
    this.user = this.$user.profile
  }
}
